import * as React from "react";
import ContainerBox from "myshubhlife-component/container-box";
import {connect} from "react-redux";
import {useEffect, useState} from "react";
import {useLocation, useHistory} from "react-router-dom";
import BasicCard from "myshubhlife-component/card";
import {CardRow} from "Loans/utils";
import Button from "myshubhlife-component/button";
import "Loans/Rloc/styles.scss";
import {websiteUrl} from "config";
import {PaymentDetailsRoutes} from "Loans/routes";
import {Loan} from "Loans/interface";
import TransactionDetails from "Loans/Rloc/RlocInfo/TransactionDetails";
import "./styles.scss";
import {setAndroidTokenAndVersionBeforeRedirecting} from "utils/android";
import {getIdToken} from "service";
import {COLOR, CC_EMAIL_ID} from "utils/variables";

interface IConnectProps {
  isAndroid: boolean;
  loanList: Loan[];
  loanIndex: number;
  apiVersion: number;
}

interface CardDetails {
  title: string;
  value: string;
}

const RlocInfo = (props: IConnectProps) => {
  const location = useLocation();
  const history = useHistory();
  const [rlocInfo, updateRlocInfo] = useState(null);
  const [loanId, updateLoanId] = useState(null);
  const [lan, upadteLan] = useState(null);
  const [txns, updateTxns] = useState(null);
  const [due, updateDue] = useState(null);
  const [loan, updateLoan] = useState(null);

  useEffect(() => {
    if (props.loanList && props.loanList.length) {
      const rlocLoan = {...props.loanList[props.loanIndex].state.loan_detail.loanDetail,
        availableLimit: props.loanList[props.loanIndex].state.available_limit,
        soa_txns: props.loanList[props.loanIndex].state.soa_txns,
        due: props.loanList[props.loanIndex].state.due,
        charges: props.loanList[props.loanIndex].state.cd,
        is_expired: props.loanList[props.loanIndex].state.is_expired,
        is_closed: props.loanList[props.loanIndex].state.is_closed,
      };
      const outstandingAmount = props.loanList[props.loanIndex].state.bills.
      map((bill) => bill.balance).reduce((prev, next) => prev + next, 0);
      const info = [
        {
          title: "Total Limit",
          value: `₹ ${rlocLoan.amount}`,
        },
        {
          title: "Interest Rate",
          value: `${rlocLoan.interestPercent}% pa`,
        },
        {
          title: "Total Outstanding",
          value: `₹ ${outstandingAmount.toFixed(2)}`,
        },
        {
          title: "Convenience Fee + GST",
          value: rlocLoan?.convenienceFeePct ?
          `${rlocLoan.convenienceFeePct}% (min ₹ ${(rlocLoan.minConvenienceFee || 0)}) + GST` :
          `₹ ${(rlocLoan.convenienceFee || 0) + (rlocLoan.convenienceFeeGst || 0)}`,
        },
        {
          title: "Processing Fee",
          value: `₹ ${(rlocLoan.processingFee || 0) + (rlocLoan.processingFeeGst || 0)}`,
        },
        ...(rlocLoan.charges && rlocLoan.charges > 0 ? [{
          title: "Total Charges Due",
          value: `₹ ${rlocLoan.charges.toFixed(2)}`,
        }] : []),
        {
          title: "Available Limit",
          value: `₹ ${rlocLoan.availableLimit > 0 ? rlocLoan.availableLimit.toFixed(2) : 0}`,
        },
      ];
      const total = rlocLoan.due && (rlocLoan.due.principal + rlocLoan.due.interest + rlocLoan.due.charges);
      const dueDetails = rlocLoan.due && total && [
        {
          title: "Principal",
          value: `₹ ${rlocLoan.due.principal.toFixed(2)}`,
        },
        {
          title: "Interest",
          value: `₹ ${rlocLoan.due.interest.toFixed(2)}`,
        },
        // {
        //   title: "Charges",
        //   value: `₹ ${rlocLoan.due.charges}`,
        // },
        {
          title: "Date",
          value: `${new Date(rlocLoan.due.date  - new Date().getTimezoneOffset() * 60000).toUTCString().slice(4, 16)}`,
        },
        // {
        //   title: "Total",
        //   value: `₹ ${total}`,
        // },
      ];
      updateDue(dueDetails);
      updateLoan(rlocLoan);
      updateRlocInfo(info);
      updateLoanId(rlocLoan.loanId);
      upadteLan(rlocLoan.lenderLoanAcctId);
      updateTxns(rlocLoan.soa_txns);
    }
  }, [props.loanList]);

  const repayment = () => {
    if (props.isAndroid) {
      setAndroidTokenAndVersionBeforeRedirecting(props.apiVersion, getIdToken());
    }
    window.open(`${websiteUrl}/repayment/#/?loan_id=${loanId}`);
  };
  const withdraw = () => {
    history.push({
      pathname: `${location.pathname}/${PaymentDetailsRoutes.WITHDRAW}`,
    });
  };

  return (
    <>
      {lan &&
      <ContainerBox pageTitle={!props.isAndroid ? `RLOC-${lan}` : ""} showBackButton={true}>
        <div className="info-container">
          <BasicCard headerTitle={"Details"}>
            <div className="details-container">
              {
                rlocInfo.map((info: CardDetails, index: number) => {
                  return <CardRow title={info.title} value={info.value} key={index}/>;
                })
              }
            </div>
            {!loan.is_closed && <div className="rloc-btn-container">
              <Button
                buttonText="Repay"
                maxWidth={95}
                height={30}
                onClick={() => repayment()}
              />
              <Button
                buttonText="Withdraw"
                maxWidth={95}
                height={30}
                onClick={() => withdraw()}
              />
            </div>}
          </BasicCard>
          {
            !!due &&
            <BasicCard headerTitle={"Due"}>
              <div className="details-container">
                {
                  due.map((info: CardDetails, index: number) => {
                    return <CardRow title={info.title} value={info.value} key={index}/>;
                  })
                }
              </div>
            </BasicCard>
          }
          {loan.is_expired && !loan.is_closed &&
            <div className="expired-info-container">
              <BasicCard>
                <h6 style={{color: COLOR.PRIMARY}}>Your loan is matured</h6>
                <div className="expired-info">
                  Please contact&nbsp;
                  <a style={{color: COLOR.PRIMARY}} href={`mailto:${CC_EMAIL_ID}`}> {CC_EMAIL_ID}</a>&nbsp;
                  to apply for another loan.
                </div>
              </BasicCard>
            </div>
          }
          {txns && !!txns.length && <TransactionDetails />}
        </div>
      </ContainerBox>
      }
    </>
  );
};

const mapStateToProps = (state): IConnectProps => {
  return {
      isAndroid: state.login.isAndroid,
      loanList: state.loanDetails.loansList ? state.loanDetails.loansList : [],
      loanIndex: state.loanDetails.loanIndex,
      apiVersion: state.login.apiVersion,
  };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(RlocInfo);
